import React from 'react';
import './PersonalInfo.css';

const PersonalInfo = ({ formData, setFormData, language = 'fr' }) => {
  // === TRADUCTIONS LOCALES ===
  const t = {
    title: language === 'fr' ? 'Informations Personnelles' : 'Personal Information',
    nameLabel: language === 'fr' ? 'Nom complet' : 'Full Name',
    namePlaceholder: language === 'fr' ? 'joe doh' : 'joe doh',
    addressLabel: language === 'fr' ? 'Adresse' : 'Address',
    addressPlaceholder: language === 'fr' ? 'Tunis, Tunisie' : 'Tunis, Tunisia',
    emailLabel: language === 'fr' ? 'Email' : 'Email',
    emailPlaceholder: language === 'fr' ? 'exemple@gmail.com' : 'exemple@gmail.com',
    phoneLabel: language === 'fr' ? 'Téléphone' : 'Phone',
    phonePlaceholder: language === 'fr' ? '+216 00 000 000' : '+216 00 000 000',
    linkedinLabel: language === 'fr' ? 'LinkedIn' : 'LinkedIn',
    linkedinPlaceholder: language === 'fr' ? 'linkedin.com/in/*****-' : 'linkedin.com/in/*****-',
    githubLabel: language === 'fr' ? 'GitHub' : 'GitHub',
    githubPlaceholder: language === 'fr' ? 'github.com/*****-' : 'github.com/*****-',
    portfolioLabel: language === 'fr' ? 'Portfolio' : 'Portfolio',
    portfolioPlaceholder: language === 'fr' ? '*****-.com' : '*****-.com',
    summaryLabel: language === 'fr' ? 'Description / Profil Professionnel' : 'Professional Summary / Profile',
    summaryPlaceholder: language === 'fr' 
      ? 'Jeune diplômé(e) ingénieur(e) en informatique passionné(e) par la création de solutions innovantes...' 
      : 'Recent computer engineering graduate passionate about creating innovative solutions...',
    photoLabel: language === 'fr' 
      ? 'Photo de profil (recommandée : 400x400px)' 
      : 'Profile Photo (recommended: 400x400px)',
    noPhoto: language === 'fr' ? 'Aucune photo' : 'No photo'
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData({ ...formData, photo: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="personal-info-step">
      <div className="step-header">
        <h3>{t.title}</h3>
      </div>

      <div className="form-grid">
        <div className="input-group">
          <label>{t.nameLabel}</label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            placeholder={t.namePlaceholder}
          />
        </div>

        <div className="input-group">
          <label>{t.addressLabel}</label>
          <input
            type="text"
            value={formData.address}
            onChange={(e) => setFormData({ ...formData, address: e.target.value })}
            placeholder={t.addressPlaceholder}
          />
        </div>

        <div className="input-group">
          <label>{t.emailLabel}</label>
          <input
            type="email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            placeholder={t.emailPlaceholder}
          />
        </div>

        <div className="input-group">
          <label>{t.phoneLabel}</label>
          <input
            type="text"
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            placeholder={t.phonePlaceholder}
          />
        </div>

        <div className="input-group">
          <label>{t.linkedinLabel}</label>
          <input
            type="text"
            value={formData.linkedin}
            onChange={(e) => setFormData({ ...formData, linkedin: e.target.value })}
            placeholder={t.linkedinPlaceholder}
          />
        </div>

        <div className="input-group">
          <label>{t.githubLabel}</label>
          <input
            type="text"
            value={formData.github}
            onChange={(e) => setFormData({ ...formData, github: e.target.value })}
            placeholder={t.githubPlaceholder}
          />
        </div>

        <div className="input-group">
          <label>{t.portfolioLabel}</label>
          <input
            type="text"
            value={formData.portfolio}
            onChange={(e) => setFormData({ ...formData, portfolio: e.target.value })}
            placeholder={t.portfolioPlaceholder}
          />
        </div>
      </div>

      {/* Champ Description/Profil */}
      <div className="input-group full-width">
        <label>{t.summaryLabel}</label>
        <textarea
          value={formData.summary}
          onChange={(e) => setFormData({ ...formData, summary: e.target.value })}
          placeholder={t.summaryPlaceholder}
          rows="4"
          className="summary-textarea"
        />
      </div>

      {/* Upload Photo */}
      <div className="photo-upload">
        <label>{t.photoLabel}</label>
        <input type="file" accept="image/*" onChange={handlePhotoChange} />
        
        <div className="photo-preview">
          {formData.photo ? (
            <img src={formData.photo} alt="Preview" className="preview-img" />
          ) : (
            <div className="placeholder">
              <span>{t.noPhoto}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;